import {
  EDisplayName,
  EFieldsName,
  IDataPreference
} from "@/features/financas/views/Indicadores/@types/type";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import { IFiltrosGeraisStrategy } from "./strategy/preferenciasInterfaces";
import Preferencia from "./strategy/Preferencia";

export default class FiltrosGeraisStrategy implements IFiltrosGeraisStrategy {
  createCompanies(companies: string[]): IDataPreference<string[] | string> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.empresas,
      fieldData: companies.join(","),
      displayName: EDisplayName.filtrosGerais,
      id: EWidgets.Preferencias
    });

    return preferencia.createPreferencesData();
  }

  createRangeInicio(filtro: string): IDataPreference<string> {
    const periodoInicio = new Preferencia({
      fieldName: EFieldsName.periodoInicio,
      fieldData: filtro,
      displayName: EDisplayName.filtrosGerais,
      id: EWidgets.Preferencias
    });

    return periodoInicio.createPreferencesData();
  }

  createRangeFim(filtro: string): IDataPreference<string> {
    const periodoFim = new Preferencia({
      fieldName: EFieldsName.periodoFim,
      fieldData: filtro,
      displayName: EDisplayName.filtrosGerais,
      id: EWidgets.Preferencias
    });

    return periodoFim.createPreferencesData();
  }
}
